import { HeadData } from '@/components/HeadData';
import { useNavigate } from '@tanstack/react-router';
import Page from '../-Page';

export type CourseLessonReflectionContainerProps = {
  lessonName: string;
  chapterName: string;
  userAttendanceSlug: string;
  lessonSlug: string;
  onEmbaStartCourseLesson: () => Promise<void>;
  headTitle: string;
};

export const CourseLessonReflectionContainer = ({
  lessonName,
  chapterName,
  userAttendanceSlug,
  lessonSlug,
  onEmbaStartCourseLesson,
  headTitle,
}: CourseLessonReflectionContainerProps) => {
  const navigate = useNavigate();

  const onClickStart = async () => {
    await onEmbaStartCourseLesson();
    navigate({
      to: '/user-attendances/$userAttendanceSlug/lessons/$lessonSlug/reflection-description',
      params: { userAttendanceSlug, lessonSlug },
    });
  };

  return (
    <>
      <HeadData title={headTitle} />
      <Page
        lessonName={lessonName}
        chapterName={chapterName}
        onClickStart={onClickStart}
      />
    </>
  );
};
